import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phoneFormat',
  standalone: true
})
export class PhoneFormatPipe implements PipeTransform {
  
  /**
   * Formats phone number by adding spaces
   * Converts +36203333333 to +36 20 333 3333
   */
  transform(phoneNumber: string | null | undefined): string {
    if (!phoneNumber) return '';
    
    // Remove all spaces first
    const cleanNumber = phoneNumber.replace(/\s/g, '');
    
    // Check if it matches the pattern without spaces: +36[area code][7 digits]
    const withoutSpacesPattern = /^\+36(20|30|31|50|70)(\d{3})(\d{4})$/;
    const match = cleanNumber.match(withoutSpacesPattern);
    
    if (match) {
      // Format as: +36 [area] [first3] [last4]
      return `+36 ${match[1]} ${match[2]} ${match[3]}`;
    }
    
    // Return original if doesn't match pattern
    return phoneNumber;
  }
}